// auto-generated by Typewriter template _enums.tst from PortCall.Models\Utils\CompassPoint.cs
export enum CompassPoint { 
    North = 0,
    NorthByEast = 1,
    NorthNorthEast = 2,
    NorthEastByNorth = 3,
    NorthEast = 4,
    NorthEastByEast = 5,
    EastNorthEast = 6,
    EastByNorth = 7,
    East = 8,
    EastBySouth = 9,
    EastSouthEast = 10,
    SouthEastByEast = 11,
    SouthEast = 12,
    SouthEastBySouth = 13,
    SouthSouthEast = 14,
    SouthByEast = 15,
    South = 16,
    SouthByWest = 17,
    SouthSouthWest = 18,
    SouthWestBySouth = 19,
    SouthWest = 20,
    SouthWestByWest = 21,
    WestSouthWest = 22,
    WestBySouth = 23,
    West = 24,
    WestByNorth = 25,
    WestNorthWest = 26,
    NorthWestByWest = 27,
    NorthWest = 28,
    NorthWestByNorth = 29,
    NorthNorthWest = 30,
    NorthByWest = 31
}

export const CompassPointDisplayName : { [val : number] : string } = { 
    0: 'North',
    1: 'NorthByEast',
    2: 'NorthNorthEast',
    3: 'NorthEastByNorth',
    4: 'NorthEast',
    5: 'NorthEastByEast',
    6: 'EastNorthEast',
    7: 'EastByNorth',
    8: 'East',
    9: 'EastBySouth',
    10: 'EastSouthEast',
    11: 'SouthEastByEast',
    12: 'SouthEast',
    13: 'SouthEastBySouth',
    14: 'SouthSouthEast',
    15: 'SouthByEast',
    16: 'South',
    17: 'SouthByWest',
    18: 'SouthSouthWest',
    19: 'SouthWestBySouth',
    20: 'SouthWest',
    21: 'SouthWestByWest',
    22: 'WestSouthWest',
    23: 'WestBySouth',
    24: 'West',
    25: 'WestByNorth',
    26: 'WestNorthWest',
    27: 'NorthWestByWest',
    28: 'NorthWest',
    29: 'NorthWestByNorth',
    30: 'NorthNorthWest',
    31: 'NorthByWest'
}

export const CompassPoints : { Id : CompassPoint, Name : string }[] = [ 
    { Id: CompassPoint.North, Name: 'North' },
    { Id: CompassPoint.NorthByEast, Name: 'NorthByEast' },
    { Id: CompassPoint.NorthNorthEast, Name: 'NorthNorthEast' },
    { Id: CompassPoint.NorthEastByNorth, Name: 'NorthEastByNorth' },
    { Id: CompassPoint.NorthEast, Name: 'NorthEast' },
    { Id: CompassPoint.NorthEastByEast, Name: 'NorthEastByEast' },
    { Id: CompassPoint.EastNorthEast, Name: 'EastNorthEast' },
    { Id: CompassPoint.EastByNorth, Name: 'EastByNorth' },
    { Id: CompassPoint.East, Name: 'East' },
    { Id: CompassPoint.EastBySouth, Name: 'EastBySouth' },
    { Id: CompassPoint.EastSouthEast, Name: 'EastSouthEast' },
    { Id: CompassPoint.SouthEastByEast, Name: 'SouthEastByEast' },
    { Id: CompassPoint.SouthEast, Name: 'SouthEast' },
    { Id: CompassPoint.SouthEastBySouth, Name: 'SouthEastBySouth' },
    { Id: CompassPoint.SouthSouthEast, Name: 'SouthSouthEast' },
    { Id: CompassPoint.SouthByEast, Name: 'SouthByEast' },
    { Id: CompassPoint.South, Name: 'South' },
    { Id: CompassPoint.SouthByWest, Name: 'SouthByWest' },
    { Id: CompassPoint.SouthSouthWest, Name: 'SouthSouthWest' },
    { Id: CompassPoint.SouthWestBySouth, Name: 'SouthWestBySouth' },
    { Id: CompassPoint.SouthWest, Name: 'SouthWest' },
    { Id: CompassPoint.SouthWestByWest, Name: 'SouthWestByWest' },
    { Id: CompassPoint.WestSouthWest, Name: 'WestSouthWest' },
    { Id: CompassPoint.WestBySouth, Name: 'WestBySouth' },
    { Id: CompassPoint.West, Name: 'West' },
    { Id: CompassPoint.WestByNorth, Name: 'WestByNorth' },
    { Id: CompassPoint.WestNorthWest, Name: 'WestNorthWest' },
    { Id: CompassPoint.NorthWestByWest, Name: 'NorthWestByWest' },
    { Id: CompassPoint.NorthWest, Name: 'NorthWest' },
    { Id: CompassPoint.NorthWestByNorth, Name: 'NorthWestByNorth' },
    { Id: CompassPoint.NorthNorthWest, Name: 'NorthNorthWest' },
    { Id: CompassPoint.NorthByWest, Name: 'NorthByWest' }
]

export enum CompassPointType { 
    Cardinal = 8,
    Ordinal = 4,
    SecondaryInterCardinal = 2,
    QuarterWind = 1
}

export const CompassPointTypeDisplayName : { [val : number] : string } = { 
    8: 'Cardinal',
    4: 'Ordinal',
    2: 'SecondaryInterCardinal',
    1: 'QuarterWind'
}

export const CompassPointTypes : { Id : CompassPointType, Name : string }[] = [ 
    { Id: CompassPointType.Cardinal, Name: 'Cardinal' },
    { Id: CompassPointType.Ordinal, Name: 'Ordinal' },
    { Id: CompassPointType.SecondaryInterCardinal, Name: 'SecondaryInterCardinal' },
    { Id: CompassPointType.QuarterWind, Name: 'QuarterWind' }
]



// WEBPACK FOOTER //
// ./server/enums/CompassPoint.ts